import '@/js/dist/www.iichi.com/common';

import { createApp, h } from 'vue';
import { uniq } from '@/js/lib/helper/array';
import { pinia } from '@/js/lib/store';
import { useEventStore } from '@/js/lib/store/event';
import FindEvents from '@/js/components/event/FindEvents.vue';
import EventLikeButtonSmall from '@/js/components/www.iichi.com/organisms/EventLikeButtonSmall.vue';

document.addEventListener('DOMContentLoaded', () => {
  createApp(FindEvents).mount('find-events');

  const eventButtonEls: NodeListOf<HTMLElement> = document.querySelectorAll('event-like-button-small');
  if (eventButtonEls.length > 0) {
    const eventStore = useEventStore(pinia);
    const eventIds = Array.from(eventButtonEls, (el) => Number(el.dataset.eventId));
    eventStore.checkLiked(uniq(eventIds));
    eventButtonEls.forEach((el) => {
      createApp({
        render: () =>
          h(EventLikeButtonSmall, {
            eventId: Number(el.dataset.eventId),
          }),
      }).mount(el);
    });
  }
});
